/**
 * paysafe.js is imported in index.html and exposes `window.paysafe`.
 * This module serves only to provide that object as an export.
 * Importing the module is more clear then simply plucking it from thin (global) air.
 * Also eslint complains that it is undefined unless you use `window.paysafe`.
 */
export default window.paysafe;



// WEBPACK FOOTER //
// ./src/lib/paysafe/index.js